var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCerveaur(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 3.33304C8.001 3.0664 7.94846 2.80228 7.84568 2.55624C7.7429 2.3102 7.59195 2.08719 7.40173 1.90034C7.2115 1.71348 6.98583 1.56656 6.73798 1.4682C6.49014 1.36983 6.22513 1.32203 5.95854 1.32758C5.69195 1.33314 5.42917 1.39195 5.18564 1.50055C4.94211 1.60916 4.72276 1.76536 4.54048 1.95998C4.3582 2.1546 4.21668 2.3837 4.12425 2.63381C4.03181 2.88392 3.99032 3.14999 4.00221 3.41637C3.61035 3.51713 3.24655 3.70574 2.93837 3.96792C2.63019 4.23009 2.38571 4.55896 2.22344 4.92961C2.06118 5.30026 1.98539 5.70297 2.0018 6.10725C2.01822 6.51153 2.12643 6.90677 2.31821 7.26304C1.981 7.537 1.71583 7.88919 1.54577 8.289C1.37571 8.6888 1.30592 9.1241 1.34245 9.55703C1.37899 9.98996 1.52076 10.4074 1.75542 10.7731C1.99008 11.1387 2.31052 11.4415 2.68888 11.655C2.64216 12.0165 2.67004 12.3838 2.7708 12.7341C2.87157 13.0844 3.04308 13.4103 3.27474 13.6917C3.50639 13.9731 3.79329 14.204 4.11769 14.3702C4.4421 14.5364 4.79713 14.6343 5.16086 14.6579C5.5246 14.6815 5.88931 14.6303 6.23247 14.5074C6.57563 14.3846 6.88997 14.1927 7.15605 13.9435C7.42214 13.6944 7.63433 13.3934 7.77952 13.0591C7.92471 12.7248 7.99982 12.3642 8.00021 11.9997V3.33304Z",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 3.33304C7.99922 3.0664 8.05177 2.80228 8.15455 2.55624C8.25733 2.3102 8.40827 2.08719 8.5985 1.90034C8.78872 1.71348 9.01439 1.56656 9.26224 1.4682C9.51008 1.36983 9.77509 1.32203 10.0417 1.32758C10.3083 1.33314 10.5711 1.39195 10.8146 1.50055C11.0581 1.60916 11.2775 1.76536 11.4597 1.95998C11.642 2.1546 11.7835 2.3837 11.876 2.63381C11.9684 2.88392 12.0099 3.14999 11.998 3.41637C12.3899 3.51713 12.7537 3.70574 13.0619 3.96792C13.37 4.23009 13.6145 4.55896 13.7768 4.92961C13.939 5.30026 14.0148 5.70297 13.9984 6.10725C13.982 6.51153 13.8738 6.90677 13.682 7.26304C14.0192 7.537 14.2844 7.88919 14.4545 8.289C14.6245 8.6888 14.6943 9.1241 14.6578 9.55703C14.6212 9.98996 14.4795 10.4074 14.2448 10.7731C14.0101 11.1387 13.6897 11.4415 13.3113 11.655C13.3581 12.0165 13.3302 12.3838 13.2294 12.7341C13.1287 13.0844 12.9571 13.4103 12.7255 13.6917C12.4938 13.9731 12.2069 14.204 11.8825 14.3702C11.5581 14.5364 11.2031 14.6343 10.8394 14.6579C10.4756 14.6815 10.1109 14.6303 9.76775 14.5074C9.42459 14.3846 9.11025 14.1927 8.84417 13.9435C8.57808 13.6944 8.36589 13.3934 8.2207 13.0591C8.07551 12.7248 8.0004 12.3642 8.00001 11.9997V3.33304Z",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.66667C9.4403 8.46977 8.95155 8.11133 8.59555 7.63667C8.23956 7.16201 8.0323 6.59245 8 6C7.9677 6.59245 7.76045 7.16201 7.40445 7.63667C7.04845 8.11133 6.5597 8.46977 6 8.66667",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7329 4.33366C11.8943 4.05405 11.9855 3.73954 11.9989 3.41699",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00195 3.41699C4.01514 3.73948 4.10617 4.05399 4.26729 4.33366",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31787 7.264C2.43983 7.16467 2.57034 7.07633 2.70787 7",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.292 7C13.4295 7.07633 13.56 7.16467 13.682 7.264",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99981 12.0003C3.54036 12.0005 3.08865 11.882 2.68848 11.6562",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3113 11.6562C12.9112 11.882 12.4594 12.0005 12 12.0003",
    stroke: "#F93E73",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerveaur);
export default __webpack_public_path__ + "static/media/cerveaur.77bd19317b0ee87a7a63ac24ac821509.svg";
export { ForwardRef as ReactComponent };